import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import { getAvailableColumns } from './api';

export const path = '/serviceBook';

const PageServiceDictionary: React.FC = (props) => {
  const ServiceDictionary = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ServiceDictionary {...props} />;
};

export default PageServiceDictionary;
